import headingSVG from '@plone/volto/icons/heading.svg';
import Edit from './Edit';
import View from './View';

interface HeadingBlock {
  tag?: string;
  heading?: string;
  [key: string]: any;
}

export const juntsHeadingBlock = {
  id: 'junts_heading',
  title: 'Junts Heading',
  icon: headingSVG,
  group: 'text',
  view: View,
  edit: Edit,
  restricted: false,
  mostUsed: true,
  sidebarTab: 1,
  blockHasOwnFocusManagement: true,
  default_tag: 'h2',
  allowed_headings: ['h1', 'h2', 'h3'],
  show_alignment: true,
  // integration with volto-block-toc
  tocEntry: (block: HeadingBlock = {}) => {
    const { tag, heading } = block;
    return heading && tag ? [parseInt(tag.slice(1)), heading] : null;
  },
};
